import { render, staticRenderFns } from "./SuspendAccount.vue?vue&type=template&id=2e3e68a6&"
import script from "./SuspendAccount.vue?vue&type=script&lang=js&"
export * from "./SuspendAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports